/**
 * YouTube URL에서 video ID를 추출합니다.
 * 지원 형식:
 * - https://www.youtube.com/watch?v=VIDEO_ID
 * - https://youtu.be/VIDEO_ID
 * - https://www.youtube.com/embed/VIDEO_ID
 * - https://youtube.com/shorts/VIDEO_ID
 */
const YOUTUBE_REGEX =
  /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})(?:[^\s<]*)/g;

/**
 * HTML 콘텐츠 내 YouTube 링크를 임베드 iframe으로 변환합니다.
 * <a> 태그로 감싸진 링크와 텍스트로 노출된 URL 모두 처리합니다.
 */
export const embedYouTubeInHTML = (html) => {
  if (!html) return html;

  // 1. <a> 태그로 감싸진 YouTube 링크를 iframe으로 변환
  const anchorRegex =
    /<a[^>]*href=["'](?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})[^"']*["'][^>]*>.*?<\/a>/gi;
  let result = html.replace(anchorRegex, (_, videoId) => buildIframe(videoId));

  // 2. 남은 텍스트 URL도 변환 (이미 iframe으로 변환된 것 제외)
  result = result.replace(YOUTUBE_REGEX, (match, videoId) => {
    // 이미 iframe src 안에 있는 URL은 건너뜀
    if (match.includes('iframe')) return match;
    return buildIframe(videoId);
  });

  return result;
};

/**
 * 플레인 텍스트 내 YouTube URL을 찾아 임베드 iframe으로 변환합니다.
 * URL이 아닌 텍스트는 그대로 유지합니다.
 */
export const embedYouTubeInText = (text) => {
  if (!text) return null;

  const parts = [];
  let lastIndex = 0;
  const regex = new RegExp(YOUTUBE_REGEX.source, 'g');
  let match;

  while ((match = regex.exec(text)) !== null) {
    // YouTube URL 이전 텍스트
    if (match.index > lastIndex) {
      parts.push({ type: 'text', content: text.slice(lastIndex, match.index) });
    }
    parts.push({ type: 'youtube', videoId: match[1] });
    lastIndex = regex.lastIndex;
  }

  // 나머지 텍스트
  if (lastIndex < text.length) {
    parts.push({ type: 'text', content: text.slice(lastIndex) });
  }

  return parts;
};

const buildIframe = (videoId) =>
  `<div style="position:relative;padding-bottom:56.25%;height:0;overflow:hidden;max-width:100%;margin:12px 0;">` +
  `<iframe src="https://www.youtube.com/embed/${videoId}" ` +
  `style="position:absolute;top:0;left:0;width:100%;height:100%;border:0;" ` +
  `allow="accelerometer;autoplay;clipboard-write;encrypted-media;gyroscope;picture-in-picture" ` +
  `allowfullscreen></iframe></div>`;
